import CodiceFiscale from 'codice-fiscale-js'
import map from 'lodash/map'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  customerUpdate,
  fetching,
  phaseChange,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import { putClienti, putClientiCallback } from '../../../actions/buy/Clienti'
import { transazioniCreateSepaIntent } from '../../../actions/buy/Transazioni'
import { errorNotice } from '../../../actions/ErrorNotice'
import { putClientiV1 } from '../../../actions/noleggia/Clienti'
import {
  getComuniNazioniV1,
  searchComuniV2Cittadinanza,
  searchComuniV2LuogoNascita,
  searchComuniV2Residenza,
} from '../../../actions/noleggia/Comuni'
import {
  getNltTabelleDominioCaricaPrivataV1,
  getNltTabelleDominioOccupazioneV1,
  getNltTabelleDominioRuoloPaV1,
  getNltTabelleDominioSettoreV1,
  getNltTabelleDominioSituazioneAbitativaV1,
  getNltTabelleDominioSituazioneLavorativaV1,
  getNltTabelleDominioStatoCivileV1,
  getNltTabelleDominioTipologiaContrattoV1,
  nltUpdateDati,
  nltUpdatePaymentMethod,
  postNltDatiClienteV1,
} from '../../../actions/noleggia/Nlt'
import verify from '../../../modules/verify'
import {
  hasValidPermessoDiSoggiorno,
  isApicale,
  isAutonomo,
  isConiugato,
  isDipendente,
  isRealLavoro,
  kycArvalApicale,
  puoNoleggiareNltBrumbrum,
  richiedeCaricaPrivata,
} from '../../../utils/nltUtils'
import {
  getCodiceCastale,
  transformCittadinanzaDefaultValue,
  transformComuniCittadinanzaV2Result,
  transformComuniNazioniDefaultValue,
  transformComuniResidenzaV2Result,
  transformComuniV2Result,
} from '../../../utils/searchComuniUtils'
import BuyDataForm from '../../buy/dumb/BuyDataForm'
import BuyDateInput from '../../buy/dumb/BuyDateInput'
import BuyRadioInput from '../../buy/dumb/BuyRadioInput'
import BuySelectInput2 from '../../buy/dumb/BuySelectInput2'
import BuyTextInput from '../../buy/dumb/BuyTextInput'
import BuyTextInput2 from '../../buy/dumb/BuyTextInput2'
import InputHint from '../../Input/InputHint'
import PhoneInput from '../../Input/Phone'
import NoleggiaIbanElementWrapper from '../../stripe'

export class NoleggiaDataForm extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.section = 1
    this.state.toTop = false
    this.handleSubmit = this.handleSubmit.bind(this)
    this.createOrUpdateClienteBeforStripe =
      this.createOrUpdateClienteBeforStripe.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRadio = this.handleRadio.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.againstMap = this.againstMap.bind(this)
    this.validate = this.validate.bind(this)
    this.state.flagDomicilio = false
    this.state.flagResidenza = false

    this.refCivicoConsegna = React.createRef()
    this.refIndirizzoConsegna = React.createRef()

    this.state.show_condizioni_generali_di_contratto_modal = false
    this.state.show_termini_di_utilizzo_modal = false
    this.state.cap_residenza = this.props.customer.cap_residenza || ''
    this.state.caps_residenza = this.props.customer.caps_residenza || []
    this.state.select_cap_residenza =
      this.props.customer.select_cap_residenza || false

    this.state.cap_domicilio = this.props.customer.cap_domicilio || ''
    this.state.caps_domicilio = this.props.customer.caps_domicilio || []
    this.state.select_cap_domicilio =
      this.props.customer.select_cap_domicilio || false

    this.state.cap_consegna = this.props.customer.cap_consegna || ''
    this.state.caps_consegna = this.props.customer.caps_consegna || []
    this.state.select_cap_consegna =
      this.props.customer.select_cap_consegna || false

    this.state.dati_cliente_nome_error = ''
    this.state.dati_cliente_cognome_error = ''
    this.state.dati_cliente_phone_error = ''
    this.state.dati_cliente_email_error = ''
    this.state.dati_cliente_sesso_error = ''
    this.state.dati_cliente_data_di_nascita_nlt_error = ''
    this.state.dati_cliente_comune_nascita_error = ''
    this.state.dati_cliente_codice_fiscale_error = ''
    this.state.dati_cliente_partita_iva_error = ''

    this.state.dati_cliente_citta_residenza_error = ''
    this.state.dati_cliente_cap_residenza_error = ''
    this.state.dati_cliente_indirizzo_residenza_error = ''
    this.state.dati_cliente_numero_civico_residenza_error = ''

    this.state.dati_cliente_citta_consegna_error = ''
    this.state.dati_cliente_cap_consegna_error = ''
    this.state.dati_cliente_indirizzo_consegna_error = ''
    this.state.dati_cliente_numero_civico_consegna_error = ''

    this.state.dati_cliente_domicilio_diverso_error = ''
    this.state.dati_cliente_condizioni_brumbrum_obbligatorie_error = ''
    this.state.dati_cliente_citta_domicilio_error = ''
    this.state.dati_cliente_cap_domicilio_error = ''
    this.state.dati_cliente_indirizzo_domicilio_error = ''
    this.state.dati_cliente_civico_domicilio_error = ''
    this.state.dati_cliente_cittadinanza_error = ''
    this.state.dati_nlt_situazione_abitativa_error = ''
    this.state.dati_nlt_stato_civile_error = ''
    this.state.dati_nlt_situazione_lavorativa_error = ''
    this.state.dati_nlt_occupazione_error = ''
    this.state.dati_nlt_tipo_contratto_error = ''
    this.state.dati_nlt_data_termine_contratto_error = ''
    this.state.dati_nlt_reddito_mensile_error = ''
    this.state.dati_nlt_anzianita_error = ''
    this.state.dati_nlt_nome_societa_error = ''
    this.state.dati_nlt_anni_apertura_conto_error = ''
    this.state.dati_nlt_stripe_payment_method_error = ''
    this.state.dati_nlt_relazione_intestatario_iban_error = ''
    this.state.dati_nlt_consenso_base_privacy_arval_error = ''
    this.state.dati_nlt_autocertificazione_1_error = ''
    this.state.dati_nlt_autocertificazione_2_error = ''
    this.state.dati_nlt_carica_privata_error = ''
    this.state.dati_nlt_altre_fonti_switch_error = ''
    this.state.dati_nlt_altre_fonti_reddito_error = ''
    this.state.dati_nlt_carica_pubblica_switch_error = ''
    this.state.dati_nlt_carica_pubblica_error = ''
    this.state.dati_nlt_reddito_coniuge_error = ''
    this.state.dati_nlt_settore_error = ''
    this.state.dati_nlt_professione_error = ''
    this.state.dati_cliente_fatturazione_uguale_error = ''
    this.state.dati_cliente_cap_fatturazione_error = ''
    this.state.dati_cliente_indirizzo_fatturazione_error = ''
    this.state.dati_cliente_numero_civico_fatturazione_error = ''
    this.state.dati_cliente_ragione_sociale_error = ''
    this.state.dati_cliente_dettaglio_ruolo_pa_error = ''
    this.state.caps_fatturazione = this.props.customer.caps_fatturazione || []
    this.state.cap_fatturazione = this.props.customer.cap_fatturazione || ''
    this.state.select_cap_fatturazione =
      this.props.customer.select_cap_fatturazione || false
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
    if (this.props.customer) {
      map(this.props.customer, (value, key) => {
        if (typeof value === 'string') {
          this.validate(`dati_cliente_${key}`, value)
        }
      })
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 30, last: 20 })

    this.props.getComuniNazioniV1()
    this.props.getNltTabelleDominioTipologiaContrattoV1()
    this.props.getNltTabelleDominioSettoreV1()
    this.props.getNltTabelleDominioStatoCivileV1()
    this.props.getNltTabelleDominioSituazioneLavorativaV1()
    this.props.getNltTabelleDominioSituazioneAbitativaV1()
    this.props.getNltTabelleDominioOccupazioneV1()
    this.props.getNltTabelleDominioCaricaPrivataV1()
    this.props.getNltTabelleDominioRuoloPaV1()

    this.props.storeDumpItForce()
  }

  cleanUpField(ref) {
    if (!ref || !ref.current) {
      return
    }

    ref.current.querySelector('input').value = ''
  }

  validate(
    label,
    value,
    nltHandler = null,
    requireAttention = false,
    showError = true
  ) {
    const v = verify(label, value, this.againstMap(label))
    const t = this
    if (showError) {
      const newState = {}
      if (v.is_required || !v.is_valid) {
        newState[`${label}_error`] = v.is_required
          ? ' is-required'
          : ' is-error'
      } else {
        newState[`${label}_error`] = ' is-ok'
      }
      Object.keys(v.updates.states).forEach(key => {
        newState[key] = v.updates.states[key]
      })
      Object.keys(v.updates.stores).forEach(key => {
        const updateHandler =
          nltHandler !== null ? nltHandler : t.props.customerUpdate
        updateHandler({
          [key]: v.updates.stores[key],
        })
      })
      this.setState(newState, () => {
        if (
          requireAttention &&
          document.querySelectorAll('.is-error, .is-required').length > 0
        ) {
          animateScroll.scrollTo(
            document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
              95,
            {
              smooth: true,
              dynamic: true,
            }
          )
        }
      })
    }
    return v
  }

  againstMap(label) {
    const t = this

    let against = {
      dati_cliente_data_rilascio_permesso_soggiorno: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita_nlt,
      },
      dati_cliente_citta_residenza: {
        dati_cliente_caps_residenza: t.props.customer.caps_residenza || [],
      },
      dati_cliente_citta_domicilio: {
        dati_cliente_caps_domicilio: t.props.customer.caps_domicilio || [],
      },
      dati_cliente_codice_fiscale: {
        nome: t.props.customer.nome || '',
        cognome: t.props.customer.cognome || '',
        sesso: t.props.customer.sesso || '',
        data_di_nascita: t.props.customer.data_di_nascita_nlt,
        paese_comune_di_nascita: t.props.customer.comune_nascita || '',
      },
      dati_cliente_citta_fatturazione: {
        dati_cliente_caps_fatturazione:
          t.props.customer.caps_fatturazione || [],
      },
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      against = {
        ...against,
        dati_cliente_citta_consegna: {
          dati_cliente_caps_consegna: t.props.customer.caps_consegna || [],
        },
      }

      this.state.dati_cliente_cap_consegna_error = ''
    }

    return against[label]
  }

  validationMapDatiPersonali() {
    const t = this
    let validationMap = {
      dati_cliente_nome: t.props.customer.nome || '',
      dati_cliente_cognome: t.props.customer.cognome || '',
      dati_cliente_data_di_nascita_nlt:
        t.props.customer.data_di_nascita_nlt.raw || '',
      dati_cliente_comune_nascita: t.props.customer.comune_nascita || '',
      dati_cliente_codice_fiscale: t.props.customer.codice_fiscale || '',
      dati_cliente_email: t.props.customer.email || '',
      dati_cliente_phone: t.props.customer.phone || '',
      dati_cliente_sesso: t.props.customer.sesso || '',
      dati_cliente_cittadinanza: t.props.customer.cittadinanza || '',
      dati_nlt_stato_civile: t.props.nlt.dati.stato_civile || '',
    }

    const codiceCittadinanza = this.props.customer.cittadinanza
      ? this.props.customer.cittadinanza.split('|')[0]
      : ''
    const cittadinanzaIsExtraEuByCodice =
      this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice

    if (cittadinanzaIsExtraEuByCodice[codiceCittadinanza]) {
      validationMap = {
        ...validationMap,
        dati_cliente_tipo_permesso_soggiorno:
          t.props.customer.tipo_permesso_soggiorno,
      }

      if (t.props.customer.tipo_permesso_soggiorno === 'temporary') {
        validationMap = {
          ...validationMap,
          dati_cliente_data_rilascio_permesso_soggiorno:
            t.props.customer.data_rilascio_permesso_soggiorno.raw || '',
          dati_cliente_data_scadenza_permesso_soggiorno:
            t.props.customer.data_scadenza_permesso_soggiorno.raw || '',
        }
      }
    }

    if (t.props.customer.fatturazione_uguale === '0') {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_fatturazione:
          t.props.customer.citta_fatturazione || '',
        dati_cliente_cap_fatturazione:
          t.state.cap_fatturazione || t.props.customer.cap_fatturazione || '',
        dati_cliente_indirizzo_fatturazione:
          t.props.customer.indirizzo_fatturazione || '',
        dati_cliente_numero_civico_fatturazione:
          t.props.customer.numero_civico_fatturazione || '',
        dati_cliente_ragione_sociale: t.props.customer.ragione_sociale || '',
      }
    }

    return validationMap
  }

  validationMapResidenzaDomicilio() {
    const t = this
    let validationMap = {
      dati_cliente_citta_residenza: t.props.customer.citta_residenza || '',
      dati_cliente_cap_residenza:
        t.state.cap_residenza || t.props.customer.cap_residenza || '',
      dati_cliente_indirizzo_residenza:
        t.props.customer.indirizzo_residenza || '',
      dati_cliente_numero_civico_residenza:
        t.props.customer.numero_civico_residenza || '',
      dati_cliente_domicilio_diverso: t.props.customer.domicilio_diverso || '0',
      dati_nlt_situazione_abitativa:
        t.props.nlt.dati.situazione_abitativa || '',
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_consegna: t.props.customer.citta_consegna || '',
        dati_cliente_cap_consegna:
          t.state.cap_consegna || t.props.customer.cap_consegna || '',
        dati_cliente_indirizzo_consegna:
          t.props.customer.indirizzo_consegna || '',
        dati_cliente_numero_civico_consegna:
          t.props.customer.numero_civico_consegna || '',
      }
    }

    if (t.props.customer.domicilio_diverso === '1') {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_domicilio: t.props.customer.citta_domicilio || '',
        dati_cliente_cap_domicilio:
          t.state.cap_domicilio || t.props.customer.cap_domicilio || '',
        dati_cliente_indirizzo_domicilio:
          t.props.customer.indirizzo_domicilio || '',
        dati_cliente_civico_domicilio: t.props.customer.civico_domicilio || '',
      }
    }

    return validationMap
  }

  validationMapLavoro() {
    const t = this

    const validationMap = {
      dati_nlt_situazione_lavorativa:
        t.props.nlt.dati.situazione_lavorativa || '',
      dati_nlt_altre_fonti_switch: t.props.nlt.dati.altre_fonti_switch || '0',
      dati_nlt_carica_pubblica_switch:
        t.props.nlt.dati.carica_pubblica_switch || '0',
    }

    if (t.props.nlt.dati.altre_fonti_switch === '1') {
      validationMap.dati_nlt_altre_fonti_reddito =
        t.props.nlt.dati.altre_fonti_reddito
    }

    //  eslint-disable-next-line
    if (t.props.nlt.dati.piva_switch == 1) {
      validationMap.dati_cliente_partita_iva = t.props.customer.partita_iva
    }

    if (t.props.nlt.dati.carica_pubblica_switch === '1') {
      validationMap.dati_nlt_carica_pubblica = t.props.nlt.dati.carica_pubblica
    }

    if (isAutonomo(t.props.nlt.dati.situazione_lavorativa)) {
      // In caso di Autonomo/Libero professionista
      validationMap.dati_nlt_settore = t.props.nlt.dati.settore
      validationMap.dati_nlt_professione = t.props.nlt.dati.professione
    }

    if (
      richiedeCaricaPrivata(
        t.props.nlt.dati.situazione_lavorativa,
        t.props.nlt.dati.occupazione
      )
    ) {
      validationMap.dati_nlt_carica_privata =
        t.props.nlt.dati.carica_privata || ''
    }

    if (isConiugato(t.props.nlt.dati.stato_civile)) {
      validationMap.dati_nlt_reddito_coniuge =
        t.props.nlt.dati.reddito_coniuge || '0'
    }

    if (
      isRealLavoro(
        t.props.nlt.dati.situazione_lavorativa,
        t.props.nlt.dati.tipo_contratto
      )
    ) {
      validationMap.dati_nlt_nome_societa = t.props.nlt.dati.nome_societa || ''
      validationMap.dati_nlt_anzianita = t.props.nlt.dati.anzianita || ''
    }

    if (
      puoNoleggiareNltBrumbrum(
        t.props.nlt.dati.situazione_lavorativa,
        t.props.nlt.dati.tipo_contratto
      )
    ) {
      validationMap.dati_nlt_reddito_mensile =
        t.props.nlt.dati.reddito_mensile || ''
    }

    if (isDipendente(t.props.nlt.dati.situazione_lavorativa)) {
      validationMap.dati_nlt_tipo_contratto =
        t.props.nlt.dati.tipo_contratto || ''
      validationMap.dati_nlt_occupazione = t.props.nlt.dati.occupazione || ''
    }

    return validationMap
  }

  validationMapContoCorrente() {
    const t = this

    const validationMap = {
      dati_nlt_anni_apertura_conto: t.props.nlt.dati.anni_apertura_conto || '',
      dati_nlt_stripe_payment_method: t.props.nlt.stripePaymentMethod || '',
      // dati_nlt_relazione_intestatario_iban: t.props.nlt.dati.relazione_intestatario_iban || '',
    }
    return validationMap
  }

  validationMapPrivacy() {
    const t = this

    const validationMap = {
      dati_nlt_autocertificazione_1:
        t.props.nlt.dati.autocertificazione_1 || '',
      dati_nlt_presa_visione_condizioni_brumbrum:
        t.props.nlt.dati.presa_visione_condizioni_brumbrum || '',
      dati_nlt_consenso_base_privacy_brumbrum:
        t.props.nlt.dati.consenso_base_privacy_brumbrum || '',
    }
    return validationMap
  }

  handlePrev() {
    this.setState({ section: this.state.section - 1 })
    animateScroll.scrollToTop()
  }

  handleNext(sezione) {
    const t = this
    return () => {
      let validationMap = {}

      switch (sezione) {
        case 'dati_personali':
          validationMap = t.validationMapDatiPersonali()
          break
        case 'residenza_e_domicilio':
          validationMap = t.validationMapResidenzaDomicilio()
          break
        case 'lavoro':
          validationMap = t.validationMapLavoro()
          break
        case 'conto_corrente':
          validationMap = t.validationMapContoCorrente()
          break
        case 'privacy':
          validationMap = t.validationMapPrivacy()
          break
        default:
          break
      }

      const validationResults = Object.keys(validationMap).map(key => {
        const isValid = t.validate(key, validationMap[key], null, true).is_valid
        return isValid
      })

      if (
        validationResults.length > 0 &&
        validationResults.indexOf(false) === -1
      ) {
        const newSectionIndex = t.state.section + 1
        t.setState({ section: newSectionIndex })
        animateScroll.scrollToTop()
        t.props.storeDumpItForce()
        if (sezione === 'lavoro') {
          t.createOrUpdateClienteBeforStripe()
        }
        if (sezione === 'privacy') {
          t.handleSubmit()
        }
      }
    }
  }

  handleInput(label, nltHandler = null) {
    const t = this
    return event => {
      const validateLabelPrefix =
        nltHandler !== null ? 'dati_nlt_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        event.target ? event.target.value : event.value,
        nltHandler
      )

      const updateHandler =
        nltHandler !== null ? nltHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale(updateHandler, validateLabelPrefix, {
        [validateLabelPrefix + label]: v.value,
      })
    }
  }

  handleSelect(label, nltHandler = null) {
    const t = this

    return selected => {
      const validateLabelPrefix =
        nltHandler !== null ? 'dati_nlt_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        selected ? selected.value : '',
        nltHandler
      )

      const updateHandler =
        nltHandler !== null ? nltHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale(updateHandler, validateLabelPrefix, {
        [validateLabelPrefix + label]: v.value,
      })
    }
  }

  handleRadio(label, nltHandler = null, isNumber = false) {
    const t = this

    return event => {
      const validateLabelPrefix =
        nltHandler !== null ? 'dati_nlt_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        isNumber ? parseInt(event.target.value) : event.target.value,
        nltHandler
      )

      const updateHandler =
        nltHandler !== null ? nltHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale(updateHandler, validateLabelPrefix, {
        [validateLabelPrefix + label]: v.value,
      })

      if (label === 'documento') {
        t.setState({ [label]: v.value })
      }
    }
  }

  handleCheckbox(label, nltHandler = null) {
    const t = this
    return event => {
      const validateLabelPrefix =
        nltHandler !== null ? 'dati_nlt_' : 'dati_cliente_'

      const v = t.validate(
        validateLabelPrefix + label,
        event.target.checked,
        nltHandler
      )

      const updateHandler =
        nltHandler !== null ? nltHandler : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  createOrUpdateClienteBeforStripe() {
    // FIXME identica a handleSubmit
    // solo che non fa il reroute

    this.props
      .putClientiV1()
      .then(() => {
        this.props
          .postNltDatiClienteV1()
          .then(() => {
            this.props.storeDumpItForce()
          })
          .catch(() => {
            this.handlePrev()
          })
      })
      .catch(() => {
        this.handlePrev()
      })
  }

  handleSubmit() {
    this.props
      .putClientiV1()
      .then(() => {
        this.props
          .postNltDatiClienteV1()
          .then(() => {
            /*
		   * temporaneamente spostata la firma digitale
		   * post upload documenti
            if (isNltBrumbrum(this.props.product)) {
              // bisogna assicurarci il dump
              // dello store prima del redirect
              this.props.setFetching({ fetching: true });
              this.props.storeDumpItForce({
                redirect_to: `${window.location.origin}/firma-nlt-brumbrum/landing/${this.props.ordine.id_ordine}?token=${this.props.customer.token}`,
              });
            } else {
	    */
            this.props.reroute('/documents')
            // }
          })
          .catch(() => {
            this.handlePrev()
          })
      })
      .catch(() => {
        this.handlePrev()
      })
  }

  autoFillCodiceFiscale(updateAction, dataPrefix, newData) {
    let validation_map = {}
    validation_map[`${dataPrefix}nome`] = this.props.customer.nome || ''
    validation_map[`${dataPrefix}cognome`] = this.props.customer.cognome || ''
    validation_map[`${dataPrefix}sesso`] = this.props.customer.sesso || ''
    validation_map[`${dataPrefix}data_di_nascita_nlt`] =
      this.props.customer.data_di_nascita_nlt.raw || ''
    validation_map[`${dataPrefix}comune_nascita`] =
      this.props.customer.comune_nascita || ''
    if (newData[`${dataPrefix}data_di_nascita_nlt`]) {
      newData[`${dataPrefix}data_di_nascita_nlt`] =
        newData[`${dataPrefix}data_di_nascita_nlt`].raw
    }
    validation_map = { ...validation_map, ...newData }

    const validation_results = Object.keys(validation_map).map(
      key =>
        this.validate(key, validation_map[key], false, false, false).is_valid
    )

    if (
      validation_results.length > 0 &&
      validation_results.indexOf(false) === -1
    ) {
      const birthplace = getCodiceCastale(
        validation_map.dati_cliente_comune_nascita
      )
      const cf = new CodiceFiscale({
        name: validation_map.dati_cliente_nome,
        surname: validation_map.dati_cliente_cognome,
        gender: validation_map.dati_cliente_sesso,
        day: validation_map.dati_cliente_data_di_nascita_nlt.split('/')[0],
        month: validation_map.dati_cliente_data_di_nascita_nlt.split('/')[1],
        year: validation_map.dati_cliente_data_di_nascita_nlt.split('/')[2],
        birthplace,
      })
      updateAction({
        codice_fiscale: cf.code,
      })
      this.setState({
        calculated_codice_fiscale: cf.code,
        dati_cliente_codice_fiscale_error: ' is-ok',
      })
    }
  }

  render() {
    const { customer } = this.props
    const domicilioDiversoClasses =
      customer.domicilio_diverso === '1' ? 'wide' : 'wide hide'
    const domicilioDiversoThreeClasses =
      customer.domicilio_diverso === '1' ? 'three-t' : 'three-t hide'
    const domicilioDiversoTwoClasses =
      customer.domicilio_diverso === '1' ? 'two-t' : 'two-t hide'
    const codiceCittadinanza = this.props.customer.cittadinanza
      ? this.props.customer.cittadinanza.split('|')[0]
      : ''
    const cittadinanzaIsExtraEuByCodice =
      this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice
    const isCittadinanzaExtraEu = codiceCittadinanza
      ? cittadinanzaIsExtraEuByCodice[codiceCittadinanza]
      : false

    return (
      <form className="form-passaggio">
        <BuyDataForm
          active={this.state.section === 1}
          icon="user"
          name="section-1"
          title="Dati Personali"
        >
          <li className={`${this.state.dati_cliente_nome_error} wide`}>
            <input
              className="form-input big capitalize"
              data-hj-suppress
              defaultValue={customer.nome || customer.name}
              label={'Nome conducente'}
              name={'dati_cliente_nome'}
              onBlur={this.handleInput('nome')}
              placeholder={'Scrivi il Nome'}
              type="text"
            />
            <label className="label">Nome</label>
            <InputHint content={`Completo di secondo nome`} />
          </li>
          <li className={`${this.state.dati_cliente_cognome_error} wide`}>
            <input
              className="form-input big capitalize"
              data-hj-suppress
              defaultValue={customer.cognome || customer.surname}
              label={'Cognome'}
              name={'dati_cliente_cognome'}
              onBlur={this.handleInput('cognome')}
              placeholder={'Scrivi il Cognome'}
              type="text"
            />
            <label className="label">Cognome</label>
          </li>
          <li className={`${this.state.dati_cliente_email_error} wide`}>
            <input
              className="form-input big"
              data-hj-suppress
              defaultValue={customer.email}
              label={'Email'}
              name={'dati_cliente_email'}
              onBlur={this.handleInput('email')}
              placeholder={'es: mario.rossi@gmail.com'}
              type="email"
            />
            <label className="label">Email</label>
          </li>
          <li
            className={`${this.state.dati_cliente_phone_error} wide`}
            style={{ marginBottom: 0 }}
          >
            <PhoneInput
              hasHint
              name={'dati_cliente_phone'}
              onChange={this.handleInput('phone')}
              placeholder={'Scrivi il tuo Numero di cellulare'}
              value={customer.phone}
            />
          </li>
          <li className="hr" />
          <li className="wide">
            <label>Sesso</label>
          </li>
          <BuyRadioInput
            defaultValue={customer.sesso}
            label={'sesso'}
            liClassName={`${this.state.dati_cliente_sesso_error} wide`}
            spanClass="value small"
            update={this.handleRadio('sesso')}
            values={[
              { label: 'Femmina', value: 'F' },
              { label: 'Maschio', value: 'M' },
            ]}
          />
          <li className="hr" />
          <li
            className={`${this.state.dati_cliente_data_di_nascita_nlt_error} wide`}
          >
            <BuyDateInput
              classes="form-input big"
              defaultValue={this.props.customer.data_di_nascita_nlt.raw || ''}
              label={'Data di nascita (gg/mm/aaaa)'}
              name={'data_di_nascita_nlt'}
              placeholder={'00/00/0000'}
              update={this.handleInput('data_di_nascita_nlt')}
            />
            <InputHint
              content={`Puoi noleggiare solo se hai un etá compresa fra 18 e 75 anni`}
            />
          </li>
          {this.props.comuni && this.props.comuni.comune ? (
            <BuySelectInput2
              async
              defaultValue={customer.comune_nascita}
              label="Comune di nascita (o Stato estero)"
              liClassName={`${this.state.dati_cliente_comune_nascita_error} wide`}
              loadOptions={searchQuery => {
                const c = customer.comune_nascita
                  ? customer.comune_nascita.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2LuogoNascita(sq)
                  .then(json => transformComuniV2Result(json.result))
              }}
              name={'comune_nascita'}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect('comune_nascita')}
              values={
                this.props.comuni.searchLuogoNascita.length
                  ? this.props.comuni.searchLuogoNascita
                  : [
                      transformComuniNazioniDefaultValue(
                        customer.comune_nascita
                      ),
                    ].filter(_ => _)
              }
            />
          ) : null}
          <li className="hr" />
          <li
            className={`${this.state.dati_cliente_codice_fiscale_error} wide`}
          >
            <BuyTextInput
              classes="form-input big uppercase"
              defaultValue={customer.codice_fiscale}
              label={'Codice Fiscale'}
              name={'dati_cliente_codice_fiscale'}
              onInput={event =>
                this.setState({ calculated_codice_fiscale: event.target.value })
              }
              placeholder={'Scrivi il Codice fiscale'}
              type={'text'}
              update={this.handleInput('codice_fiscale')}
              value={this.state.calculated_codice_fiscale}
            />
          </li>

          <li className="hr" />

          <BuySelectInput2
            async
            defaultValue={customer.cittadinanza}
            label={'Cittadinanza'}
            liClassName={`${this.state.dati_cliente_cittadinanza_error} wide`}
            loadOptions={searchQuery => {
              const c = customer.cittadinanza
                ? customer.cittadinanza.split('|')[1]
                : ''
              const sq = searchQuery || c
              return this.props
                .searchComuniV2Cittadinanza(sq)
                .then(
                  json =>
                    transformComuniCittadinanzaV2Result(json.result)
                      .cittadinanza
                )
            }}
            name={'dati_cliente_cittadinanza'}
            placeholder={'Seleziona la Cittadinanza'}
            update={this.handleSelect('cittadinanza')}
            values={
              this.props.comuni.searchCittadinanza.length
                ? this.props.comuni.searchCittadinanza.cittadinanza
                : [
                    transformCittadinanzaDefaultValue(customer.cittadinanza),
                  ].filter(_ => _)
            }
          />

          {isCittadinanzaExtraEu && ( // Tipo di permesso di soggiorno
            <li
              className={`${
                this.props.customer.tipo_permesso_soggiorno !== null
                  ? 'is-ok'
                  : null
              } wide`}
            >
              <BuySelectInput2
                clearable={false}
                defaultValue={this.props.customer.tipo_permesso_soggiorno}
                label={'Permesso di soggiorno'}
                name={'tipo_permesso_soggiorno'}
                placeholder={'Permesso di soggiorno'}
                update={this.handleSelect('tipo_permesso_soggiorno')}
                values={[
                  {
                    label: 'Permesso con durata illimitata',
                    value: 'unlimited',
                  },
                  {
                    label: 'Permesso temporaneo o con data di scadenza',
                    value: 'temporary',
                  },
                ]}
              />
            </li>
          )}

          {this.props.customer.tipo_permesso_soggiorno === 'temporary' &&
          hasValidPermessoDiSoggiorno(
            this.props.customer.tipo_permesso_soggiorno
          ) ? (
            <React.Fragment>
              <li
                className={`${this.state.dati_cliente_data_rilascio_permesso_soggiorno_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.customer.data_rilascio_permesso_soggiorno.raw ||
                    ''
                  }
                  label={'Soggiorno dal (mm/aaaa)'}
                  mask="99/9999"
                  name={'dati_cliente_data_rilascio_permesso_soggiorno'}
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput('data_rilascio_permesso_soggiorno')}
                />
              </li>
              <li
                className={`${this.state.dati_cliente_data_scadenza_permesso_soggiorno_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.customer.data_scadenza_permesso_soggiorno.raw ||
                    ''
                  }
                  label={'Data di scadenza permesso (gg/mm/aaaa)'}
                  name={'dati_cliente_data_scadenza_permesso_soggiorno'}
                  placeholder={'00/00/0000'}
                  type={'text'}
                  update={this.handleInput('data_scadenza_permesso_soggiorno')}
                />
              </li>
            </React.Fragment>
          ) : null}

          {hasValidPermessoDiSoggiorno(
            this.props.customer.tipo_permesso_soggiorno
          ) ? (
            <React.Fragment>
              <li className="hr" />

              <BuySelectInput2
                defaultValue={this.props.nlt.dati.stato_civile}
                label={'Stato Civile'}
                liClassName={`${this.state.dati_nlt_stato_civile_error} wide`}
                name={'dati_nlt_stato_civile'}
                placeholder={'Seleziona lo Stato civile'}
                update={this.handleSelect(
                  'stato_civile',
                  this.props.nltUpdateDati
                )}
                values={this.props.nlt.statoCivile}
              />
            </React.Fragment>
          ) : null}

          <li className="hr" />

          {!hasValidPermessoDiSoggiorno(
            this.props.customer.tipo_permesso_soggiorno
          ) ? (
            <li className="wide form-title">
              <p className="static__section__description">
                A causa della tipologia del documento siamo spiacenti di
                comunicarti che non possiamo accogliere la tua richiesta di
                noleggio a lungo termine. Per valutare soluzioni alternative
                contatta il nostro Servizio Clienti al numero{' '}
                <a href={`tel:${this.props.ui.settings.phoneNumber}`}>
                  02.800.29
                </a>
              </p>
            </li>
          ) : null}

          <li className="wide buttons">
            {hasValidPermessoDiSoggiorno(
              this.props.customer.tipo_permesso_soggiorno
            ) ? (
              <a
                className="btn btn-primary js-next-step"
                onClick={this.handleNext('dati_personali')}
              >
                <span>Prosegui</span>
              </a>
            ) : null}
          </li>
        </BuyDataForm>
        <BuyDataForm
          active={this.state.section === 2}
          icon="home"
          name="section-2"
          title="Residenza e domicilio"
        >
          <li className="hr" />

          <BuySelectInput2
            defaultValue={this.props.nlt.dati.situazione_abitativa}
            label={'Situazione abitativa'}
            liClassName={`${this.state.dati_nlt_situazione_abitativa_error} wide`}
            name={'dati_nlt_situazione_abitativa'}
            placeholder={'Seleziona la Situazione abitativa'}
            update={this.handleSelect(
              'situazione_abitativa',
              this.props.nltUpdateDati
            )}
            values={this.props.nlt.situazioneAbitativa}
          />

          {this.props.comuni && this.props.comuni.comune ? (
            <BuySelectInput2
              async
              defaultValue={customer.citta_residenza}
              label="Comune di residenza"
              liClassName={`${this.state.dati_cliente_citta_residenza_error} two-t`}
              loadOptions={searchQuery => {
                const c = customer.citta_residenza
                  ? customer.citta_residenza.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              name={'dati_cliente_citta_residenza'}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect('citta_residenza')}
              values={
                this.props.comuni.searchComuneResidenza.length
                  ? this.props.comuni.searchComuneResidenza
                  : [
                      transformComuniNazioniDefaultValue(
                        customer.citta_residenza
                      ),
                    ].filter(_ => _)
              }
            />
          ) : null}
          {this.state.select_cap_residenza && (
            <BuySelectInput2
              clearable={false}
              defaultValue={customer.cap_residenza}
              label="Cap"
              liClassName={`${this.state.dati_cliente_cap_residenza_error} three-t`}
              name={'dati_cliente_cap_residenza'}
              placeholder={'Cap'}
              update={this.handleSelect('cap_residenza')}
              values={this.state.caps_residenza}
            />
          )}
          {!this.state.select_cap_residenza && (
            <li
              className={`${this.state.dati_cliente_cap_residenza_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Cap'}
                type={'number'}
                update={this.handleInput('cap_residenza')}
                value={customer.cap_residenza}
              />
            </li>
          )}
          <li
            className={`${this.state.dati_cliente_indirizzo_residenza_error} two-t`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.indirizzo_residenza}
              label={'Indirizzo di residenza'}
              onInput={this.handleInput('indirizzo_residenza')}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_residenza')}
            />
          </li>
          <li
            className={`${this.state.dati_cliente_numero_civico_residenza_error} three-t`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.numero_civico_residenza}
              label={'Civico'}
              onInput={this.handleInput('numero_civico_residenza')}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('numero_civico_residenza')}
            />
          </li>

          <li className="hr" />

          <li className="wide form-title">
            <label>I dati di fatturazione sono uguali alla residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={
              customer.fatturazione_uguale
                ? `${customer.fatturazione_uguale}`
                : '1'
            }
            label={'fatturazione_uguale'}
            liClassName={`${this.state.dati_cliente_fatturazione_uguale_error} wide`}
            update={this.handleRadio('fatturazione_uguale')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_ragione_sociale_error} wide`}
            >
              <BuyTextInput
                classes="form-input big uppercase"
                defaultValue={customer.ragione_sociale}
                label={'Ragione sociale (facoltativa)'}
                name={'dati_cliente_ragione_sociale'}
                placeholder={'Scrivi la Ragione sociale'}
                type={'text'}
                update={this.handleInput('ragione_sociale')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <BuySelectInput2
              async
              defaultValue={customer.citta_fatturazione}
              label="Comune di fatturazione"
              liClassName={`${this.state.dati_cliente_citta_fatturazione_error} two-t `}
              loadOptions={searchQuery => {
                const c = customer.citta_fatturazione
                  ? customer.citta_fatturazione.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              name={'dati_cliente_citta_fatturazione'}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect('citta_fatturazione')}
              values={
                this.props.comuni.searchComuneResidenza.length
                  ? this.props.comuni.searchComuneResidenza
                  : [
                      transformComuniNazioniDefaultValue(
                        customer.citta_fatturazione
                      ),
                    ].filter(_ => _)
              }
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          this.state.select_cap_fatturazione ? (
            <BuySelectInput2
              clearable={false}
              defaultValue={customer.cap_fatturazione}
              label={'Cap'}
              liClassName={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
              name={'dati_cliente_cap_fatturazione'}
              placeholder={'Cap'}
              update={this.handleInput('cap_fatturazione')}
              values={this.state.caps_fatturazione}
            />
          ) : null}

          {customer.fatturazione_uguale === '0' &&
          !this.state.select_cap_fatturazione ? (
            <li
              className={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                name={'dati_cliente_cap_fatturazione'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_fatturazione')}
                value={customer.cap_fatturazione}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_indirizzo_fatturazione_error} two-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_fatturazione}
                label={'Indirizzo di fatturazione'}
                name={'dati_cliente_indirizzo_fatturazione'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_fatturazione')}
              />
            </li>
          ) : null}

          {customer.fatturazione_uguale === '0' ? (
            <li
              className={`${this.state.dati_cliente_numero_civico_fatturazione_error} three-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.numero_civico_fatturazione}
                label={'Civico'}
                name={'dati_cliente_numero_civico_fatturazione'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_fatturazione')}
              />
            </li>
          ) : null}

          <li className="hr" />
          <li className="wide form-title">
            <label>Il domicilio è diverso dall’indirizzo di residenza?</label>
          </li>
          <BuyRadioInput
            defaultValue={customer.domicilio_diverso || '0'}
            label={'domicilio_diverso'}
            liClassName={`${this.state.dati_cliente_domicilio_diverso_error} wide`}
            update={this.handleRadio('domicilio_diverso')}
            values={[
              { label: 'No', value: '0' },
              { label: 'Si', value: '1' },
            ]}
          />

          <li className={`${domicilioDiversoClasses} hr`} />
          {this.props.comuni && this.props.comuni.comune ? (
            <BuySelectInput2
              async
              defaultValue={customer.citta_domicilio}
              label="Comune di domicilio"
              liClassName={domicilioDiversoTwoClasses.concat(
                this.state.dati_cliente_citta_domicilio_error
              )}
              loadOptions={searchQuery => {
                const c = customer.citta_domicilio
                  ? customer.citta_domicilio.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              update={this.handleSelect('citta_domicilio')}
              values={
                this.props.comuni.searchComuneResidenza.length
                  ? this.props.comuni.searchComuneResidenza
                  : [
                      transformComuniNazioniDefaultValue(
                        customer.citta_domicilio
                      ),
                    ].filter(_ => _)
              }
            />
          ) : null}
          {this.state.select_cap_domicilio && (
            <BuySelectInput2
              clearable={false}
              defaultValue={customer.cap_domicilio}
              label="Cap"
              liClassName={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
              update={this.handleSelect('cap_domicilio')}
              values={this.state.caps_domicilio}
            />
          )}
          {!this.state.select_cap_domicilio && (
            <li
              className={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_cap_domicilio_error
              )}
            >
              <BuyTextInput2
                classes="input-data form-input big"
                disabled
                label={'Cap'}
                placeholder={'Scrivi il Cap'}
                type={'number'}
                update={this.handleInput('cap_domicilio')}
                value={customer.cap_domicilio}
              />
            </li>
          )}
          <li
            className={domicilioDiversoTwoClasses.concat(
              this.state.dati_cliente_indirizzo_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.indirizzo_domicilio}
              label={'Indirizzo di domicilio'}
              onInput={this.handleInput('indirizzo_domicilio')}
              placeholder={"Scrivi l'indirizzo"}
              type={'text'}
              update={this.handleInput('indirizzo_domicilio')}
            />
          </li>
          <li
            className={domicilioDiversoThreeClasses.concat(
              this.state.dati_cliente_civico_domicilio_error
            )}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={customer.civico_domicilio}
              label={'Civico'}
              onInput={this.handleInput('civico_domicilio')}
              placeholder={'Civico'}
              type={'text'}
              update={this.handleInput('civico_domicilio')}
            />
          </li>

          {/* scelta consegna */}

          <BuyDataForm
            active={
              this.state.section === 2 &&
              this.props.logistica.centro_convenzionato.tipologia_consegna ===
                'Consegna a casa'
            }
            icon="home"
            id={'consegna_domicilio'}
            name="section-consegna-domicilio"
            title="Indirizzo per la consegna della tua auto"
          >
            {this.props.customer.citta_residenza &&
            this.props.customer.cap_residenza &&
            this.props.customer.indirizzo_residenza &&
            this.props.customer.numero_civico_residenza ? (
              <li style={{ margin: '0', width: '50%' }}>
                <label className="r-checkbox long">
                  <input
                    checked={this.state.flagResidenza}
                    name="flagResidenza"
                    onChange={() => {
                      this.setState(
                        prevState => ({
                          flagResidenza: !prevState.flagResidenza,
                        }),

                        () => {
                          if (this.state.flagResidenza) {
                            this.setState(
                              {
                                flagDomicilio: false,
                              },

                              () => {
                                this.handleSelect('citta_consegna')({
                                  value: this.props.customer.citta_residenza,
                                })

                                this.handleSelect('cap_consegna')({
                                  value: this.props.customer.cap_residenza,
                                })

                                this.handleInput('indirizzo_consegna')({
                                  value:
                                    this.props.customer.indirizzo_residenza,
                                })

                                this.handleInput('numero_civico_consegna')({
                                  value:
                                    this.props.customer.numero_civico_residenza,
                                })
                              }
                            )
                          }

                          if (
                            !this.state.flagResidenza &&
                            !this.state.flagDomicilio
                          ) {
                            this.handleSelect('citta_consegna')({
                              value: '',
                            })

                            this.handleSelect('cap_consegna')({
                              value: '',
                            })

                            this.handleInput('indirizzo_consegna')({
                              value: '',
                            })

                            this.handleInput('numero_civico_consegna')({
                              value: '',
                            })

                            this.cleanUpField(this.refCivicoConsegna)
                            this.cleanUpField(this.refIndirizzoConsegna)
                          }
                        }
                      )
                    }}
                    type="checkbox"
                  />
                  <span className="check"></span>
                  Copia da residenza
                </label>
              </li>
            ) : null}

            {this.props.customer.domicilio_diverso === '1' &&
            this.props.customer.citta_domicilio &&
            this.props.customer.cap_domicilio &&
            this.props.customer.indirizzo_domicilio &&
            this.props.customer.civico_domicilio ? (
              <li style={{ margin: '0', width: '50%' }}>
                <label className="r-checkbox long">
                  <input
                    checked={this.state.flagDomicilio}
                    name="flagDomicilio"
                    onChange={() => {
                      this.setState(
                        prevState => ({
                          flagDomicilio: !prevState.flagDomicilio,
                        }),

                        () => {
                          if (this.state.flagDomicilio) {
                            this.setState(
                              {
                                flagResidenza: false,
                              },

                              () => {
                                this.handleSelect('citta_consegna')({
                                  value: this.props.customer.citta_domicilio,
                                })

                                this.handleSelect('cap_consegna')({
                                  value: this.props.customer.cap_domicilio,
                                })

                                this.handleInput('indirizzo_consegna')({
                                  value:
                                    this.props.customer.indirizzo_domicilio,
                                })

                                this.handleInput('numero_civico_consegna')({
                                  value: this.props.customer.civico_domicilio,
                                })
                              }
                            )
                          }

                          if (
                            !this.state.flagResidenza &&
                            !this.state.flagDomicilio
                          ) {
                            this.handleSelect('citta_consegna')({
                              value: '',
                            })

                            this.handleSelect('cap_consegna')({
                              value: '',
                            })

                            this.handleInput('indirizzo_consegna')({
                              value: '',
                            })

                            this.handleInput('numero_civico_consegna')({
                              value: '',
                            })

                            this.cleanUpField(this.refCivicoConsegna)
                            this.cleanUpField(this.refIndirizzoConsegna)
                          }
                        }
                      )
                    }}
                    type="checkbox"
                  />
                  <span className="check"></span>
                  Copia da domicilio
                </label>
              </li>
            ) : null}

            <li className="hr" style={{ margin: '20px 0' }} />

            {this.props.comuni &&
            this.props.comuni.comune &&
            !this.state.flagResidenza &&
            !this.state.flagDomicilio ? (
              <BuySelectInput2
                async
                defaultValue={customer.citta_consegna}
                label="Comune di consegna"
                liClassName={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                loadOptions={searchQuery => {
                  const c = customer.citta_consegna
                    ? customer.citta_consegna.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props
                    .searchComuniV2Residenza(sq)
                    .then(json => transformComuniResidenzaV2Result(json.result))
                }}
                name={'dati_cliente_citta_consegna'}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('citta_consegna')}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.citta_consegna
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}

            {this.props.comuni &&
              this.props.comuni.comune &&
              (this.state.flagResidenza || this.state.flagDomicilio) && (
                <li
                  className={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                >
                  <BuyTextInput2
                    classes="input-data form-input big"
                    defaultValue={customer.citta_consegna}
                    disabled
                    label="Comune di consegna"
                    name={'dati_cliente_citta_consegna'}
                    placeholder={'Seleziona il Comune'}
                    update={this.handleSelect('citta_consegna')}
                    value={
                      transformComuniNazioniDefaultValue(
                        customer.citta_consegna
                      ) &&
                      transformComuniNazioniDefaultValue(
                        customer.citta_consegna
                      ).label
                    }
                  />
                </li>
              )}

            {this.state.select_cap_consegna && (
              <BuySelectInput2
                clearable={false}
                defaultValue={customer.cap_consegna}
                label="Cap"
                liClassName={`${this.state.dati_cliente_cap_consegna_error} three-t`}
                name={'dati_cliente_cap_consegna'}
                placeholder={'Cap'}
                update={this.handleSelect('cap_consegna')}
                values={this.state.caps_consegna}
              />
            )}
            {!this.state.select_cap_consegna && (
              <li
                className={`${this.state.dati_cliente_cap_consegna_error} three-t`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  defaultValue={customer.cap_consegna}
                  disabled
                  label={'Cap'}
                  placeholder={'Cap'}
                  type={'number'}
                  update={this.handleInput('cap_consegna')}
                  value={customer.cap_consegna}
                />
              </li>
            )}

            <li
              className={`two-t ${this.state.dati_cliente_indirizzo_consegna_error}`}
              ref={this.refIndirizzoConsegna}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_consegna}
                disabled={this.state.flagDomicilio || this.state.flagResidenza}
                label={'Indirizzo di consegna'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_consegna')}
                value={
                  this.state.flagDomicilio || this.state.flagResidenza
                    ? customer.indirizzo_consegna
                    : null
                }
              />
            </li>
            <li
              className={`three-t ${this.state.dati_cliente_numero_civico_consegna_error}`}
              ref={this.refCivicoConsegna}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.numero_civico_consegna}
                disabled={this.state.flagDomicilio || this.state.flagResidenza}
                label={'Civico'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_consegna')}
                value={
                  this.state.flagDomicilio || this.state.flagResidenza
                    ? customer.numero_civico_consegna
                    : null
                }
              />
            </li>
          </BuyDataForm>

          <li className="hr" />

          <li className="wide buttons">
            <a
              className={`btn btn-primary js-next-step ${
                this.props.fetching ? ' btn-disabled' : ''
              }`}
              onClick={this.handleNext('residenza_e_domicilio')}
            >
              <span>Prosegui</span>
            </a>
            <a
              className="btn btn-back js-back-step mt-30"
              onClick={this.handlePrev}
            >
              Indietro
            </a>
          </li>
        </BuyDataForm>
        <BuyDataForm
          active={this.state.section === 3}
          icon="work"
          name="section-3"
          title="Lavoro"
        >
          <BuySelectInput2
            defaultValue={this.props.nlt.dati.situazione_lavorativa}
            label={'Situazione lavorativa'}
            liClassName={`${this.state.dati_nlt_situazione_lavorativa_error} wide`}
            update={this.handleSelect(
              'situazione_lavorativa',
              this.props.nltUpdateDati
            )}
            values={this.props.nlt.situazioneLavorativa}
          />

          {isAutonomo(this.props.nlt.dati.situazione_lavorativa) && (
            <BuySelectInput2
              defaultValue={this.props.nlt.dati.settore}
              label={'Settore'}
              liClassName={`${this.state.dati_nlt_settore_error} wide`}
              update={this.handleSelect('settore', this.props.nltUpdateDati)}
              values={this.props.nlt.settore}
            />
          )}

          {isDipendente(this.props.nlt.dati.situazione_lavorativa) ? (
            <BuySelectInput2
              defaultValue={this.props.nlt.dati.occupazione}
              label={'Occupazione'}
              liClassName={`${this.state.dati_nlt_occupazione_error} wide`}
              update={this.handleSelect(
                'occupazione',
                this.props.nltUpdateDati
              )}
              values={this.props.nlt.occupazione}
            />
          ) : null}

          {isAutonomo(this.props.nlt.dati.situazione_lavorativa) ? (
            <li className={`${this.state.dati_nlt_professione_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.professione}
                label={'Professione svolta (es. Avvocato)'}
                placeholder={'Scrivi la Professione'}
                type={'text'}
                update={this.handleInput(
                  'professione',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) && kycArvalApicale(this.props.nlt.dati) ? (
            <BuySelectInput2
              defaultValue={this.props.nlt.dati.dettaglio_ruolo_pa}
              label={'Ruolo'}
              liClassName={`${this.state.dati_nlt_dettaglio_ruolo_pa_error} wide`}
              optionHeight={55}
              update={this.handleSelect(
                'dettaglio_ruolo_pa',
                this.props.nltUpdateDati
              )}
              values={this.props.nlt.ruoloPa}
            />
          ) : null}

          {richiedeCaricaPrivata(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.occupazione
          ) && (
            <BuySelectInput2
              defaultValue={this.props.nlt.dati.carica_privata}
              label={'Carica Privata'}
              liClassName={`${this.state.dati_nlt_carica_privata_error} wide`}
              optionHeight={55}
              update={this.handleSelect(
                'carica_privata',
                this.props.nltUpdateDati
              )}
              values={this.props.nlt.caricaPrivata}
            />
          )}

          {isDipendente(this.props.nlt.dati.situazione_lavorativa) ? (
            <BuySelectInput2
              defaultValue={this.props.nlt.dati.tipo_contratto}
              label={'Tipo di Contratto'}
              liClassName={`${this.state.dati_nlt_tipo_contratto_error} wide`}
              update={this.handleSelect(
                'tipo_contratto',
                this.props.nltUpdateDati
              )}
              values={this.props.nlt.tipoContratto}
            />
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) ? (
            <li className={`${this.state.dati_nlt_reddito_mensile_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.reddito_mensile}
                isSymbol="input-symbol"
                label={'Il tuo reddito mensile netto'}
                placeholder={'Scrivi il Reddito mensile netto'}
                theSymbol="€"
                type={'number'}
                update={this.handleInput(
                  'reddito_mensile',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) && isConiugato(this.props.nlt.dati.stato_civile) ? (
            <li className={`${this.state.dati_nlt_reddito_coniuge_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.reddito_coniuge}
                isSymbol="input-symbol"
                label={'Reddito mensile netto del coniuge'}
                placeholder={'Scrivi il Reddito mensile netto'}
                theSymbol="€"
                type={'number'}
                update={this.handleInput(
                  'reddito_coniuge',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) &&
          ['DPU', 'DPR'].includes(this.props.nlt.dati.situazione_lavorativa) &&
          this.props.nlt.dati.tipo_contratto === 'DET' ? (
            <li
              className={`${this.state.dati_nlt_data_termine_contratto_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                label={'Data di termine del contratto (gg/mm/aaaa)'}
                name={'dati_cliente_data_termine_contratto'}
                placeholder={'00/00/0000'}
                update={this.handleInput(
                  'data_termine_contratto',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          ) : null}

          {isRealLavoro(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) ? (
            <li className={`${this.state.dati_nlt_nome_societa_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.nome_societa}
                label={'Nome Societá/Ente/Istituzione'}
                placeholder={'Scrivi il Nome'}
                type={'text'}
                update={this.handleInput(
                  'nome_societa',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          ) : null}

          {isRealLavoro(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) ? (
            <li className={`${this.state.dati_nlt_anzianita_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.anzianita}
                label={"Anni di anzianità lavorativa nell'attuale impiego"}
                placeholder={'Scrivi gli Anni'}
                type={'number'}
                update={this.handleInput('anzianita', this.props.nltUpdateDati)}
              />
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <li className="wide form-title">
              <label>
                {' '}
                Hai la Partita IVA e vuoi che sia presente in fattura?
              </label>
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <BuyRadioInput
              defaultValue={this.props.nlt.dati.piva_switch || 0}
              label={'piva_switch'}
              update={this.handleRadio(
                'piva_switch',
                this.props.nltUpdateDati,
                true
              )}
              values={[
                { label: 'No', value: 0 },
                { label: 'Si', value: 1 },
              ]}
            />
          ) : null}

          {/* eslint-disable-next-line */}
          {this.props.nlt.dati.piva_switch == 1 && (
            <React.Fragment>
              <li
                className={`${this.state.dati_cliente_partita_iva_error} wide`}
              >
                <BuyTextInput
                  classes="form-input big uppercase"
                  defaultValue={customer.partita_iva}
                  label={'Partita IVA'}
                  name={'dati_cliente_partita_iva'}
                  placeholder={'Scrivi la Partita IVA'}
                  type={'text'}
                  update={this.handleInput('partita_iva')}
                />
              </li>

              <li className="wide form-title">
                <label>
                  Compilando questo campo in fattura saranno riportati i dati di
                  Codice Fiscale e della tua Partita IVA.
                </label>
              </li>
            </React.Fragment>
          )}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <li className="wide form-title">
              <label>Hai altre fonti di reddito?</label>
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <BuyRadioInput
              defaultValue={this.props.nlt.dati.altre_fonti_switch || '0'}
              label={'altre_fonti_switch'}
              liClassName={`${this.state.dati_nlt_altre_fonti_switch_error} wide`}
              update={this.handleRadio(
                'altre_fonti_switch',
                this.props.nltUpdateDati
              )}
              values={[
                { label: 'No', value: '0' },
                { label: 'Si', value: '1' },
              ]}
            />
          ) : null}

          {this.props.nlt.dati.altre_fonti_switch === '1' && (
            <li
              className={`${this.state.dati_nlt_altre_fonti_reddito_error} wide`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.altre_fonti_reddito}
                label={'Di che tipo?'}
                placeholder={'Scrivi il Tipo'}
                type={'text'}
                update={this.handleInput(
                  'altre_fonti_reddito',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          )}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <li className="wide form-title">
              <label>
                Hai ricoperto una carica pubblica{' '}
                {isApicale(this.props.nlt.dati)
                  ? 'diversa da quella di ruolo apicale presso la Pubblica Amministrazione'
                  : ''}{' '}
                nell'ultimo anno?
              </label>
            </li>
          ) : null}

          {puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) ? (
            <BuyRadioInput
              defaultValue={this.props.nlt.dati.carica_pubblica_switch || '0'}
              label={'carica_pubblica_switch'}
              liClassName={`${this.state.dati_nlt_carica_pubblica_switch_error} wide`}
              update={this.handleRadio(
                'carica_pubblica_switch',
                this.props.nltUpdateDati
              )}
              values={[
                { label: 'No', value: '0' },
                { label: 'Si', value: '1' },
              ]}
            />
          ) : null}

          {this.props.nlt.dati.carica_pubblica_switch === '1' && (
            <li className={`${this.state.dati_nlt_carica_pubblica_error} wide`}>
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={this.props.nlt.dati.carica_pubblica}
                label={'Che tipologia di carica?'}
                placeholder={'Scrivi la Tipologia'}
                type={'text'}
                update={this.handleInput(
                  'carica_pubblica',
                  this.props.nltUpdateDati
                )}
              />
            </li>
          )}

          {!puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto,
            this.props.nlt
          ) &&
          this.props.nlt.dati.situazione_lavorativa !== '' &&
          this.props.nlt.dati.tipo_contratto === 'DET' ? (
            <li className="wide form-title">
              <p className="static__section__description">
                Siamo spiacenti di comunicarti che non possiamo accogliere la
                tua richiesta perché il contratto ha scadenza precedente a
                quella del contratto per il noleggio a lungo termine. Per
                valutare soluzioni alternative contatta il nostro Servizio
                Clienti al numero{' '}
                <a href={`tel:${this.props.ui.settings.phoneNumber}`}>
                  02.800.29
                </a>
              </p>
            </li>
          ) : null}

          {!puoNoleggiareNltBrumbrum(
            this.props.nlt.dati.situazione_lavorativa,
            this.props.nlt.dati.tipo_contratto
          ) &&
          this.props.nlt.dati.situazione_lavorativa !== '' &&
          this.props.nlt.dati.tipo_contratto !== 'DET' ? (
            <li className="wide form-title">
              <p className="static__section__description">
                A causa della situazione lavorativa siamo spiacenti di
                comunicarti che non possiamo accogliere la richiesta di noleggio
                a lungo termine. Per valutare soluzioni alternative chiama il
                nostro Servizio Clienti al numero{' '}
                <a href={`tel:${this.props.ui.settings.phoneNumber}`}>
                  02.800.29
                </a>
                !
              </p>
            </li>
          ) : null}

          <li className="wide buttons">
            {puoNoleggiareNltBrumbrum(
              this.props.nlt.dati.situazione_lavorativa,
              this.props.nlt.dati.tipo_contratto,
              this.props.nlt,
              this.props.customer
            ) ? (
              <a
                className="btn btn-primary js-next-step"
                onClick={this.handleNext('lavoro')}
              >
                <span>Prosegui</span>
              </a>
            ) : null}
            <a
              className="btn btn-back js-back-step mt-30"
              onClick={this.handlePrev}
            >
              Indietro
            </a>
          </li>
        </BuyDataForm>

        <BuyDataForm
          active={this.state.section === 4}
          icon="work"
          name="section-4"
          panel={
            <div className="panel">
              <h4 className="panel__title">
                Addebito del canone mensile, fidati è sicuro
              </h4>

              <ul>
                <li>
                  Procedi serenamente: l’
                  <b>
                    addebito del canone mensile è sempre successivo alla
                    consegna della tua auto!
                  </b>
                </li>
                <li>
                  I tuoi dati sono al sicuro: usiamo server criptati,
                  certificati SSL (Secure Sockets Layer), che garantiscono la
                  protezione dei dati sensibili.
                </li>
                <li>
                  Inserisci l’IBAN sul quale desideri venga addebitato il canone
                  mensile del noleggio a lungo termine (e degli eventuali
                  servizi plus) che stai richiedendo.
                </li>
                <li>
                  È necessario che l’IBAN sia intestato/cointestato al
                  richiedente del noleggio e che le transazioni avvengano in
                  euro. Il conto corrente deve essere stanziato in uno dei 27
                  Stati Membri dell’Unione Europea (UE), con l’aggiunta di
                  Islanda, Norvegia, Liechtenstein, Svizzera, Principato di
                  Monaco, San Marino, Dipendenze della Corona Britannica.
                </li>
              </ul>
            </div>
          }
          title="Conto Corrente"
        >
          <li
            className={`${this.state.dati_nlt_anni_apertura_conto_error} wide`}
          >
            <BuyTextInput
              classes="input-data form-input big"
              defaultValue={this.props.nlt.dati.anni_apertura_conto}
              label={'Da quanti anni è aperto il conto?'}
              placeholder={'Scrivi gli Anni'}
              type={'number'}
              update={this.handleInput(
                'anni_apertura_conto',
                this.props.nltUpdateDati
              )}
            />
          </li>

          {this.props.nlt.stripePaymentMethod ? (
            <React.Fragment>
              <li className="wide buttons">
                <p>Addebito sul conto corrente confermato correttamente</p>
              </li>
              <li className="wide buttons">
                <a
                  className={`btn btn-primary js-next-step`}
                  onClick={this.handleNext('conto_corrente')}
                >
                  <span>Prosegui</span>
                </a>
              </li>
            </React.Fragment>
          ) : (
            <NoleggiaIbanElementWrapper
              cognome={this.props.customer.cognome}
              email={this.props.customer.email}
              nome={this.props.customer.nome}
              onConfirmSepaDebitSetup={setupIntent => {
                this.props.nltUpdatePaymentMethod(setupIntent)
                this.props.storeDumpItForce()
                this.handleNext('conto_corrente')()
              }}
              onError={error => {
                this.props.errorNotice({
                  type: 'custom',
                  message:
                    error && typeof error.toString === 'function'
                      ? error.toString()
                      : error,
                  title: 'Errore durante SEPA setup',
                  logo: 'dati_non_corretti',
                })
              }}
              setIsFetching={isFetching =>
                this.props.setFetching({ fetching: isFetching })
              }
              storeDumpItForce={this.props.storeDumpItForce}
              stripeSepaIntent={this.props.nlt.stripeSepaIntent}
              transazioniCreateSepaIntent={
                this.props.transazioniCreateSepaIntent
              }
            />
          )}

          <li className="wide buttons">
            <a className="btn btn-back js-back-step" onClick={this.handlePrev}>
              Indietro
            </a>
          </li>

          <li
            className={`${this.state.dati_nlt_relazione_intestatario_iban_error} wide`}
            style={{ display: 'none' }}
          >
            <div className="relative-input">
              <BuyTextInput
                classes="input-data form-input big uppercase"
                defaultValue={this.props.nlt.dati.relazione_intestatario_iban}
                label={'Relazione intestatario IBAN'}
                placeholder={'Scrivi la Relazione'}
                type={'text'}
                update={this.handleInput(
                  'relazione_intestatario_iban',
                  this.props.nltUpdateDati
                )}
              />
            </div>
          </li>
        </BuyDataForm>

        <BuyDataForm
          active={this.state.section === 5}
          icon="work"
          name="section-5"
          title="Privacy"
        >
          <li
            className={`${this.state.dati_nlt_consenso_base_privacy_brumbrum_error} wide`}
          >
            <label>Consenso al trattamento dei dati personali</label>
            <div className="informativa">
              <p>
                I Suoi dati personali saranno trattati conformemente alla
                presente{' '}
                <a
                  href={`${window.brumbrum.url_files}/pdf/brumbrum-rent/informativa-privacy-NLT_v20062022.pdf`}
                  rel="noreferrer"
                  target="_blank"
                >
                  Informativa sul trattamento dei dati personali
                </a>
              </p>
              <label
                className={`r-checkbox list ${
                  this.props.nlt.dati.consenso_base_privacy_brumbrum === '1'
                    ? 'checked'
                    : ''
                }`}
              >
                <input
                  defaultChecked={
                    this.props.nlt.dati.consenso_base_privacy_brumbrum === '1'
                  }
                  name="consenso_base_privacy_brumbrum"
                  onChange={this.handleCheckbox(
                    'consenso_base_privacy_brumbrum',
                    this.props.nltUpdateDati
                  )}
                  type="checkbox"
                  value="1"
                />
                <span className="check"></span>
                Ho preso visione e accetto la{' '}
                <a
                  href={`${window.brumbrum.url_files}/pdf/brumbrum-rent/informativa-privacy-NLT-cazoo_v22062022.pdf`}
                  rel="noreferrer"
                  target="_blank"
                >
                  Privacy Policy NLT
                </a>
              </label>
            </div>
          </li>
          <h4>Autocertificazione</h4>
          <li
            className={`${this.state.dati_nlt_autocertificazione_1_error} wide`}
          >
            <label
              className={`r-checkbox list long ${
                this.props.nlt.dati.autocertificazione_1 === '1'
                  ? 'checked'
                  : ''
              }`}
            >
              <input
                defaultChecked={
                  this.props.nlt.dati.autocertificazione_1 === '1'
                }
                name="dati_nlt_autocertificazione_1"
                onChange={this.handleCheckbox(
                  'autocertificazione_1',
                  this.props.nltUpdateDati
                )}
                type="checkbox"
                value="1"
              />
              <span className="check"></span>
              Inviando la richiesta, dichiaro la veridicità delle informazioni
              fornite, consapevole delle responsabilità civili in caso di
              dichiarazioni false o mendaci.
            </label>
          </li>
          <li
            className={`${this.state.dati_nlt_autocertificazione_2_error} wide`}
          >
            <label
              className={`r-checkbox list long ${
                this.props.nlt.dati.presa_visione_condizioni_brumbrum === '1'
                  ? 'checked'
                  : ''
              }`}
            >
              <input
                defaultChecked={
                  this.props.nlt.dati.presa_visione_condizioni_brumbrum === '1'
                }
                name="dati_presa_visione_condizioni_brumbrum"
                onChange={this.handleCheckbox(
                  'presa_visione_condizioni_brumbrum',
                  this.props.nltUpdateDati
                )}
                type="checkbox"
                value="1"
              />
              <span className="check"></span>
              Ho preso visione delle{' '}
              <a
                href={`${window.brumbrum.url_files}/pdf/brumbrum-rent/CGC-NLT-cazoo_v22062022.pdf`}
                rel="noreferrer"
                target="_blank"
              >
                Condizioni generali di contratto quadro di locazione a lungo
                termine di veicoli senza conducente
              </a>{' '}
              di brumbrum S.p.A
            </label>
          </li>
          <li className="wide buttons">
            <a
              className={`btn btn-primary js-next-step ${
                this.props.fetching ? ' btn-disabled' : ''
              }`}
              onClick={this.handleNext('privacy')}
            >
              <span>Prosegui</span>
            </a>
          </li>
          <li className="wide buttons">
            <a className="btn btn-back js-back-step" onClick={this.handlePrev}>
              Indietro
            </a>
          </li>
        </BuyDataForm>
      </form>
    )
  }
}

NoleggiaDataForm.propTypes = {
  customer: PropTypes.object,
  customerUpdate: PropTypes.func,
  compass_tabelledominio: PropTypes.object,
  comuni: PropTypes.object,
  fetching: PropTypes.bool,
  getComuniNazioniV1: PropTypes.func,
  getNltTabelleDominioTipologiaContrattoV1: PropTypes.func,
  getNltTabelleDominioSettoreV1: PropTypes.func,
  getNltTabelleDominioStatoCivileV1: PropTypes.func,
  getNltTabelleDominioSituazioneLavorativaV1: PropTypes.func,
  getNltTabelleDominioSituazioneAbitativaV1: PropTypes.func,
  getNltTabelleDominioOccupazioneV1: PropTypes.func,
  getNltTabelleDominioCaricaPrivataV1: PropTypes.func,
  nlt: PropTypes.object,
  nltUpdateDati: PropTypes.func,
  ordine: PropTypes.object,
  phaseChange: PropTypes.func,
  putClientiV1: PropTypes.func,
  postNltDatiClienteV1: PropTypes.func,
  product: PropTypes.object,
  putClienti: PropTypes.func,
  putClientiCallback: PropTypes.func,
  reroute: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  ui: PropTypes.object,
}

const mapStateToProps = state => ({
  comuni: state.comuni,
  compass_tabelledominio: state.compass_tabelledominio,
  customer: state.customer,
  fetching: state.ui.fetching,
  logistica: state.logistica,
  nlt: state.nlt,
  ordine: state.ordine,
  product: state.product,
  ui: state.ui,
  error: state.error,
})

const mapDispatchToProps = dispatch => ({
  customerUpdate: payload => dispatch(customerUpdate(payload)),
  setFetching: payload => dispatch(fetching(payload)),
  getComuniNazioniV1: () => dispatch(getComuniNazioniV1),
  getNltTabelleDominioTipologiaContrattoV1: () =>
    dispatch(getNltTabelleDominioTipologiaContrattoV1),
  getNltTabelleDominioSettoreV1: () => dispatch(getNltTabelleDominioSettoreV1),
  getNltTabelleDominioStatoCivileV1: () =>
    dispatch(getNltTabelleDominioStatoCivileV1),
  getNltTabelleDominioSituazioneLavorativaV1: () =>
    dispatch(getNltTabelleDominioSituazioneLavorativaV1),
  getNltTabelleDominioSituazioneAbitativaV1: () =>
    dispatch(getNltTabelleDominioSituazioneAbitativaV1),
  getNltTabelleDominioOccupazioneV1: () =>
    dispatch(getNltTabelleDominioOccupazioneV1),
  getNltTabelleDominioCaricaPrivataV1: () =>
    dispatch(getNltTabelleDominioCaricaPrivataV1),
  getNltTabelleDominioRuoloPaV1: () => dispatch(getNltTabelleDominioRuoloPaV1),
  nltUpdatePaymentMethod: payload => dispatch(nltUpdatePaymentMethod(payload)),
  nltUpdateDati: payload => dispatch(nltUpdateDati(payload)),
  phaseChange: phase => dispatch(phaseChange(phase)),
  postNltDatiClienteV1: () => dispatch(postNltDatiClienteV1),
  putClienti: payload => dispatch(putClienti(payload)),
  putClientiCallback: payload => dispatch(putClientiCallback(payload)),
  putClientiV1: () => dispatch(putClientiV1),
  reroute: payload => dispatch(reroute(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  searchComuniV2LuogoNascita: searchQuery =>
    dispatch(searchComuniV2LuogoNascita(searchQuery)),
  searchComuniV2Cittadinanza: searchQuery =>
    dispatch(searchComuniV2Cittadinanza(searchQuery)),
  searchComuniV2Residenza: searchQuery =>
    dispatch(searchComuniV2Residenza(searchQuery)),
  transazioniCreateSepaIntent: () => dispatch(transazioniCreateSepaIntent),
  errorNotice: payload => dispatch(errorNotice(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NoleggiaDataForm)
